import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import PropTypes from "prop-types";
import { useCommonStore } from "../../Common/store/CommonStore";
import { cn } from "src/lib/utils";
import '../../Styles/phoneNumber.css'
import { debounce } from "lodash";
import { get } from "src/Containers/Auth/Store/Store";

const PhoneNumber = ({ value, register, required, label, name, control, onValueChange, defaultValue, rules, placeholder, errors, setValue, setError, clearErrors, userId, disabled }) => {
    const { getExistingEmailandPhoneno } = useCommonStore();
    const [phoneDetails, setPhoneDetails] = useState(null);
    const [numberValidErrMsg, setNumberValidErrMsg] = useState("");

    useEffect(() => {
        if (register && required) {
            register("phoneNumber", { required: "Phone number is required" });
            register("phoneCode", { required: "Country code is required" });
        }
    }, [register, required]);

    useEffect(() => {
        if (value) {
            const parsedPhone = parsePhoneNumberFromString(value);
            clearErrors?.(name);
            if (!isValidPhoneNumber(value)) {
                // setNumberValidErrMsg("Enter valid phone number1");
                // setError?.(name, { type: "manual", message: "Enter valid phone number2" });
            } else {
                setNumberValidErrMsg("");
                clearErrors?.(name);
            }

            if (parsedPhone) {
                setValue("phoneNumber", parsedPhone.number);
                setValue("phoneCode", `+${parsedPhone.countryCallingCode}`);
            }
        }
    }, [value, register]);

    const validatePhoneNo = async (phone) => {
        try {
            const orgId = get("orgId");
            const payload = {
                userId: userId,
                emailId: "",
                phoneCountryCode: phoneDetails?.country,
                phoneCode: `+${phoneDetails?.countryCallingCode}`,
                phoneNo: phone,
                orgId 
            };

            const response = await getExistingEmailandPhoneno(payload);
            if (response?.data === true) {
                setError?.(name, { type: "manual", message: "Phone number already exists" });
                return "Phone number already exists";
            } else {
                clearErrors?.(name);
            }
            return true;
        } catch (error) {
            console.error("API Error:", error);
            setError?.(name, { type: "manual", message: "Error validating phone number" });
        }
    };

    return (
        <div className="w-full flex flex-col justify-center">
          {label && <label className={cn('grc-label block mb-3')}>{label}{required && <span className='text-danger'>*</span>}</label>}
            
            <Controller
                name={name}
                control={control}
                defaultValue={value || ""}
                rules={{
                    ...rules,
                    validate: async  (inputValue) =>  {
                    if (required && !inputValue) return "Phone number is required";
                    const parsedPhone = parsePhoneNumberFromString(value); 
                    if (inputValue?.length > 0) {
                        if (!parsedPhone || !isValidPhoneNumber(value)) {
                            return "Enter valid phone number";
                        }
                    }
                    return await validatePhoneNo(value);
                }
                }}
                render={({ field }) => (
                    <PhoneInput
                        {...field}
                        international
                        disabled={disabled}
                        countryCallingCodeEditable={false}
                        defaultCountry={defaultValue || "IN"}
                        value={value || ""}
                        onChange={(e, idx) => {
                            field.onChange(e);
                            if (!e || typeof e !== 'string' || e.trim() === '') {
                                setPhoneDetails(null);
                                if (required) {
                                    setError?.(name, { type: "manual", message: "Phone number is required" });
                                }
                                return;
                            }
                            const parsedPhone = parsePhoneNumberFromString(e);
                            if (parsedPhone) {
                                const el = {
                                        countryCode: parsedPhone.country,
                                        phNumberCode: `+${parsedPhone.countryCallingCode}`,
                                        phNumber: parsedPhone.nationalNumber,
                                };
                                onValueChange(el,name,idx);
                                setPhoneDetails(parsedPhone);
                                setNumberValidErrMsg("");
                                clearErrors?.(name);
                            } else {
                                setPhoneDetails(null);
                            }
                        }}
                        limitMaxLength
                        numberInputProps={{
                            placeholder: { placeholder }
                        }}
                        onBlur={async (e) => {
                            field.onBlur(e); // Triggers validation only when user leaves the field
                            const inputValue = e.target.value.trim();
                            if (label === 'Phone Number') {
                                const trimmedValue = inputValue.startsWith(`+${phoneDetails?.countryCallingCode}`)  
                                    ? inputValue.slice(`+${phoneDetails?.countryCallingCode}`.length).replace(/\s+/g, '').trim() 
                                    : inputValue.replace(/\s+/g, '').trim();
                                    
                                if (inputValue) {
                                    await validatePhoneNo(phoneDetails?.nationalNumber);
                                }
                                else {
                                    clearErrors?.(name);
                                    
                                }
                            }
                        }}
                    />
                )}
            />
            
            {errors[name] && <p className="grc-error-msg text-danger">{errors[name]?.message}</p>}
            {!errors[name] && numberValidErrMsg && <p className="grc-error-msg text-danger">{numberValidErrMsg}</p>}
        </div>
    );
};

PhoneNumber.propTypes = {
    name: PropTypes.string.isRequired,
    control: PropTypes.object.isRequired,
    defaultValue: PropTypes.string,
    rules: PropTypes.object,
    placeholder: PropTypes.string,
    errors: PropTypes.object,
    setValue: PropTypes.func.isRequired,
    register: PropTypes.func.isRequired,
    setError: PropTypes.func.isRequired,
    clearErrors: PropTypes.func.isRequired,
};

export default PhoneNumber;
